/// <reference path="../../TimeTracking/PurchaseOrderLines/PurchaseOrderLinesGrid.ts" />

import { PurchaseOrderLinesRow } from "@/ServerTypes/TimeTracking";
import { PurchaseOrderLinesGrid } from "@/TimeTracking/PurchaseOrderLines/PurchaseOrderLinesGrid";
import { ColumnSelection, Decorators, ListRequest } from "@serenity-is/corelib";
import { ProjectPurchaseOrderDialog } from "./ProjectPurchaseOrderDialog";


@Decorators.registerClass("Cemdo.Projects.ProjectPurchaseOrderGrid")
export class ProjectPurchaseOrderGrid extends PurchaseOrderLinesGrid {

    protected getColumnsKey() { return "TimeTracking.ProjectPurchaseOrder" }
    protected getDialogType() { return ProjectPurchaseOrderDialog; }

    private _projectId: number;

    get projectId(): number {
        return this._projectId;
    }

    set projectId(value: number) {
        if (value != this._projectId) {
            this.setEquality(PurchaseOrderLinesRow.Fields.ProjectId, value);
            this._projectId = value;
            this.refresh();
        }
    }

    getInitialTitle() {
        return null;
    }

    protected onViewSubmit() {
        if (!super.onViewSubmit())
            return false;

        (this.view.params as ListRequest).ColumnSelection = ColumnSelection.KeyOnly;

        return true;
    }

    getIncludeColumns(include) {
        super.getIncludeColumns(include);
        include[PurchaseOrderLinesRow.Fields.DifferingDeliveryDateCommented] = true;
        include[PurchaseOrderLinesRow.Fields.DifferingDeliveryDateNew] = true;
        include[PurchaseOrderLinesRow.Fields.DelayCritically] = true;
    }

    getColumns() {
        return super.getColumns().filter(x => x.field != PurchaseOrderLinesRow.Fields.ProjectContractNo);
    }

    getGridCanLoad() {
        return super.getGridCanLoad() && !!this._projectId;
    }

    addButtonClick() {
        if (!this._projectId)
            return;
        this.editItem(<PurchaseOrderLinesRow>{
            ProjectId: this._projectId,
            DataClass: "Project"
        });
    }
}

